import React from 'react';
import SelectComponent from "../../reusable/SelectComponent";
import {useDispatch, useSelector} from "react-redux";
import {setAlarmPriority} from "../../../store/settings/actions";
import {SettingsState} from "../../../store/settings/types";
import {ApplicationState} from "../../../store";
import {APIState} from "../../../store/API/types";

const SettingsAlarmComponent = () => {
    const dispatch = useDispatch();
    const { alarmPriority } = useSelector<ApplicationState, SettingsState>(state => state.settings);
    const { username } = useSelector<ApplicationState, APIState>(state => state.API);
    const alarms = [
        {
            value: 'none',
            label: 'None'
        },
        {
            value: '0',
            label: 'All Events'
        },
        {
            value: '3',
            label: '3 and or Higher Priority'
        },
        {
            value: '5',
            label: '5 and or Higher Priority'
        },
        {
            value: '8',
            label: '8 and or Higher Priority'
        },
        {
            value: '10',
            label: '10 priority'
        }
    ];
    const onSubmit = (e: React.FormEvent<HTMLSelectElement>) => {
        e.preventDefault();
        const priority = e.currentTarget.value;
        dispatch(setAlarmPriority(priority));
        window.localStorage.setItem(`${username}/sounds`, `${e.currentTarget.value}`);
    };

    return <SelectComponent inputs={alarms}
                            selected={alarmPriority}
                            name={'Alarms'}
                            title={'Alarms: '}
                            onSubmit={ onSubmit }
    />
};

export default SettingsAlarmComponent